"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var core_1 = require("@material-ui/core");
var ux_assets_1 = require("@lifesize/ux-assets");
var share_screen_svg_1 = __importDefault(require("@lifesize/ux-assets/vectors/svgIcons/share-screen.svg"));
var video_svg_1 = __importDefault(require("@lifesize/ux-assets/vectors/svgIcons/video.svg"));
var constants_1 = require("./constants");
var RemoteVideo_1 = __importDefault(require("./RemoteVideo"));
var __1 = require("../..");
var PipType;
(function (PipType) {
    PipType["pip"] = "pip";
    PipType["pres"] = "pres";
})(PipType || (PipType = {}));
var useStyles = core_1.makeStyles(function () { return ({
    pipHolder: {
        display: 'flex',
        position: 'relative'
    },
    swapPresentation: {
        alignItems: 'center',
        backgroundColor: core_1.fade(ux_assets_1.colors.black, 0.3),
        color: ux_assets_1.colors.white,
        cursor: 'pointer',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        margin: 0,
        opacity: 0,
        position: 'absolute',
        width: '100%',
        zIndex: 1000,
        '& svg': {
            height: '80%',
            width: 'auto'
        },
        '&:hover': {
            opacity: 1
        }
    }
}); });
function PipFooter(props) {
    var _a = props.height, height = _a === void 0 ? 56 : _a, _b = props.isSinglePip, isSinglePip = _b === void 0 ? true : _b;
    var _c = react_1.useState(false), isHoveringPip = _c[0], setIsHoveringPip = _c[1];
    var _d = react_1.useState(false), isHoveringPres = _d[0], setIsHoveringPres = _d[1];
    var _e = react_1.useState(true), showPresentationAsPip = _e[0], setShowPresentationAsPip = _e[1];
    var localPresentationStream = __1.hooks.useMedia().localPresentationStream;
    var localPrimaryStream = __1.hooks.useLocalPrimaryStream();
    var videoMuted = localPrimaryStream.videoMuted;
    var classes = useStyles();
    var onHoverPip = function (hovering) {
        setIsHoveringPip(hovering);
    };
    var onHoverPres = function (hovering) {
        setIsHoveringPres(hovering);
    };
    var pipStyle = react_1.useCallback(function (pip) {
        var isHovering = (pip === PipType.pip) ? isHoveringPip : isHoveringPres;
        var pipHeight = isHovering ? height * 3 : height;
        var mutedStyles = videoMuted && (pip === PipType.pip)
            ? { width: "calc(" + pipHeight + "px * " + constants_1.aspectRatio_16to9 + ")" }
            : {};
        // returns [containerStyle, videoStyle]
        return [
            {
                bottom: 0,
                display: 'flex',
                height: pipHeight,
                left: ((pip === PipType.pres) && !isSinglePip) ? height * constants_1.aspectRatio_16to9 + constants_1.space + "px" : 0,
                margin: 0,
                position: 'absolute',
                transition: 'width .5s, height .5s',
                width: 'auto',
                zIndex: (pip === PipType.pip) ? 101 : 100
            },
            __assign({ borderRadius: '5px', height: pipHeight, objectFit: (isSinglePip && (pip !== PipType.pres)) ? 'contain' : 'cover', transition: 'width .5s, height .5s', width: (isSinglePip && (pip !== PipType.pres)) ? 'auto' : "calc(" + pipHeight + "px * " + constants_1.aspectRatio_16to9 + ")" }, mutedStyles)
        ];
    }, [isHoveringPip, isHoveringPres, isSinglePip, videoMuted]);
    var pipStylePip = pipStyle(PipType.pip);
    var pipStylePres = pipStyle(PipType.pres);
    var renderSwapIcon = react_1.useCallback(function () {
        if (!isSinglePip || !localPresentationStream)
            return null;
        return (react_1.default.createElement("div", { className: classes.swapPresentation, "data-testid": "swap-presentation", onClick: function () {
                setShowPresentationAsPip(!showPresentationAsPip);
                if (showPresentationAsPip) { // forcibly unhover the pip that will be hidden and hover the other
                    onHoverPres(false);
                    onHoverPip(true);
                }
                else {
                    onHoverPip(false);
                    onHoverPres(true);
                }
            } },
            react_1.default.createElement(react_inlinesvg_1.default, { src: showPresentationAsPip ? video_svg_1.default : share_screen_svg_1.default })));
    }, [isSinglePip, localPresentationStream, showPresentationAsPip]);
    return (react_1.default.createElement("div", { className: classes.pipHolder },
        (!localPresentationStream || !showPresentationAsPip || !isSinglePip) && (react_1.default.createElement(RemoteVideo_1.default, { dataTestId: 'pip-local-video', containerStyle: pipStylePip[0], metadata: localPrimaryStream, mirror: !localPrimaryStream.isEnvironmentFacing, muted: true, onHover: onHoverPip, showMetadata: isHoveringPip, stream: localPrimaryStream.stream, streamId: 'localVideo', videoStyle: pipStylePip[1] }, renderSwapIcon())),
        localPresentationStream && (showPresentationAsPip || !isSinglePip) && (react_1.default.createElement(RemoteVideo_1.default, { containerStyle: pipStylePres[0], dataTestId: 'pip-presentation', isPresentationPip: true, muted: true, onHover: onHoverPres, showMetadata: false, stream: localPresentationStream, streamId: 'pip-presentation', videoStyle: pipStylePres[1] }, renderSwapIcon()))));
}
exports.default = PipFooter;
